import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PrMetrics from '../../PullRequestsPage/containers/PrMetrics';
import { BasicInfoTemplate } from './BasicInfoTemplate';
import { Controls } from './Controls';
export const LoadingMetrics = ({ controls = false }) => {
    const basicInfo = {
        previousCycleTime: 0,
        currentCycleTime: 0,
        previousNumberOfPRs: 0,
        currentNumberOfPRs: 0,
    };
    return (_jsxs("div", { className: "velocity", children: [controls && _jsx(Controls, { repositoriesList: [], activeRepositoriesIds: [], repos: [], repositoriesSlugs: [] }), _jsx(BasicInfoTemplate, { basicInfo: basicInfo, loading: true }), _jsx("hr", {}), _jsx(PrMetrics, { loading: true })] }));
};
